var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconMetamask = function SvgIconMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.648 2.674-7.496 5.567 1.386-3.284 6.11-2.283Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.345 2.674 7.435 5.62-1.318-3.337-6.117-2.283ZM17.952 15.578l-1.996 3.059 4.27 1.175 1.229-4.166-3.503-.068ZM2.554 15.646l1.22 4.166 4.272-1.175-1.997-3.059-3.495.068Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.805 10.41-1.19 1.8 4.24.19-.15-4.558-2.9 2.569ZM16.189 10.41 13.25 7.79l-.098 4.61 4.233-.19-1.197-1.8ZM8.045 18.637l2.546-1.243-2.2-1.718-.346 2.96ZM13.402 17.394l2.554 1.243-.354-2.96-2.2 1.717Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.955 18.637 13.4 17.394l.203 1.664-.022.7 2.373-1.121ZM8.045 18.637l2.373 1.122-.015-.7.188-1.665-2.546 1.243Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10.455 14.576-2.124-.625 1.5-.685.624 1.31ZM13.537 14.576l.625-1.31 1.507.685-2.132.625Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m8.046 18.637.361-3.059-2.358.068 1.997 2.99ZM15.593 15.578l.362 3.059 1.996-2.991-2.358-.068ZM17.386 12.21l-4.233.19.391 2.176.626-1.31 1.506.685 1.71-1.74ZM8.332 13.951l1.507-.686.618 1.311.399-2.177-4.241-.188 1.717 1.74Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m6.613 12.21 1.778 3.466-.06-1.725-1.718-1.74ZM15.675 13.951l-.075 1.725 1.785-3.465-1.71 1.74ZM10.854 12.4l-.4 2.176.498 2.569.113-3.382-.211-1.364ZM13.151 12.4l-.203 1.355.09 3.39.505-2.569-.392-2.177Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m13.544 14.576-.505 2.569.362.249 2.2-1.718.075-1.725-2.132.625ZM8.331 13.951l.06 1.725 2.2 1.718.362-.249-.498-2.569-2.124-.625Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m13.582 19.759.022-.7-.188-.166h-2.84l-.173.165.015.7-2.373-1.121.829.677 1.68 1.168h2.884l1.688-1.168.829-.677-2.373 1.122Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m13.401 17.394-.361-.249h-2.087l-.361.249-.189 1.664.174-.165h2.84l.188.165-.204-1.664Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m20.965 8.603.64-3.074-.956-2.855-7.247 5.379 2.787 2.358 3.94 1.152.874-1.017-.377-.271.603-.55-.467-.362.602-.459-.4-.301ZM2.396 5.53l.64 3.073-.406.301.602.46-.46.361.603.55-.376.271.866 1.017 3.94-1.152 2.787-2.358-7.247-5.379-.949 2.855Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m20.128 11.563-3.94-1.152 1.198 1.8-1.785 3.465 2.35-.03h3.503l-1.326-4.083ZM7.804 10.41l-3.94 1.153-1.31 4.083h3.495l2.343.03-1.778-3.465 1.19-1.8ZM13.152 12.4l.249-4.347 1.145-3.096H9.46l1.13 3.096.264 4.346.09 1.371.008 3.375h2.086l.015-3.375.098-1.37Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgIconMetamask;